import { useCallback, useState } from 'react';
import useMeetingChat from './useMeetingChat';

/**
 * Everything about being in a meeting that is not the media itself: which side
 * panel is open, whether the room is locked, the chat, and the one banner the
 * meeting can raise ("somebody is waiting to share their screen").
 *
 * Kept apart from the room's media so that it lives as long as the meeting
 * does: the chat keeps arriving, and the banner keeps being raised, while the
 * meeting window is minimised and its screen is not even drawn.
 */
export const useMeetingSession = ({ client, initialLocked = false }) => {
    const [panel, setPanel] = useState(null); // null | 'people' | 'chat'
    const [locked, setLocked] = useState(initialLocked);
    const [notice, setNotice] = useState(null);

    const chat = useMeetingChat(client, { open: panel === 'chat', onNotice: setNotice });
    const dismissNotice = useCallback(() => setNotice(null), []);

    return { client, panel, setPanel, locked, setLocked, notice, dismissNotice, chat };
};

export default useMeetingSession;
